module.exports = __webpack_public_path__ + "media/images/icon/icons8-Download-1b00fc5f61259e7a8882d4deb705f858.png";